export interface NaicsCode {
  value: string
  label: string
}

/**
 * Complete 2022 NAICS codes (1,012 codes).
 * Source: U.S. Census Bureau 2022 NAICS.
 * Used across profile settings, opportunity matching, and opportunity filters.
 */
export const NAICS_CODES: NaicsCode[] = [
  // Agriculture, Forestry, Fishing and Hunting
  { value: "111110", label: "111110 - Soybean Farming" },
  { value: "111120", label: "111120 - Oilseed (except Soybean) Farming" },
  { value: "111130", label: "111130 - Dry Pea and Bean Farming" },
  { value: "111140", label: "111140 - Wheat Farming" },
  { value: "111150", label: "111150 - Corn Farming" },
  { value: "111160", label: "111160 - Rice Farming" },
  { value: "111191", label: "111191 - Oilseed and Grain Combination Farming" },
  { value: "111199", label: "111199 - All Other Grain Farming" },
  { value: "111211", label: "111211 - Potato Farming" },
  { value: "111219", label: "111219 - Other Vegetable (except Potato) and Melon Farming" },
  { value: "111310", label: "111310 - Orange Groves" },
  { value: "111320", label: "111320 - Citrus (except Orange) Groves" },
  { value: "111331", label: "111331 - Apple Orchards" },
  { value: "111332", label: "111332 - Grape Vineyards" },
  { value: "111333", label: "111333 - Strawberry Farming" },
  { value: "111334", label: "111334 - Berry (except Strawberry) Farming" },
  { value: "111335", label: "111335 - Tree Nut Farming" },
  { value: "111336", label: "111336 - Fruit and Tree Nut Combination Farming" },
  { value: "111339", label: "111339 - Other Noncitrus Fruit Farming" },
  { value: "111411", label: "111411 - Mushroom Production" },
  { value: "111419", label: "111419 - Other Food Crops Grown Under Cover" },
  { value: "111421", label: "111421 - Nursery and Tree Production" },
  { value: "111422", label: "111422 - Floriculture Production" },
  { value: "111910", label: "111910 - Tobacco Farming" },
  { value: "111920", label: "111920 - Cotton Farming" },
  { value: "111930", label: "111930 - Sugarcane Farming" },
  { value: "111940", label: "111940 - Hay Farming" },
  { value: "111991", label: "111991 - Sugar Beet Farming" },
  { value: "111992", label: "111992 - Peanut Farming" },
  { value: "111998", label: "111998 - All Other Miscellaneous Crop Farming" },
  { value: "112111", label: "112111 - Beef Cattle Ranching and Farming" },
  { value: "112112", label: "112112 - Cattle Feedlots" },
  { value: "112120", label: "112120 - Dairy Cattle and Milk Production" },
  { value: "112130", label: "112130 - Dual-Purpose Cattle Ranching and Farming" },
  { value: "112210", label: "112210 - Hog and Pig Farming" },
  { value: "112310", label: "112310 - Chicken Egg Production" },
  { value: "112320", label: "112320 - Broilers and Other Meat Type Chicken Production" },
  { value: "112330", label: "112330 - Turkey Production" },
  { value: "112340", label: "112340 - Poultry Hatcheries" },
  { value: "112390", label: "112390 - Other Poultry Production" },
  { value: "112410", label: "112410 - Sheep Farming" },
  { value: "112420", label: "112420 - Goat Farming" },
  { value: "112511", label: "112511 - Finfish Farming and Fish Hatcheries" },
  { value: "112512", label: "112512 - Shellfish Farming" },
  { value: "112519", label: "112519 - Other Aquaculture" },
  { value: "112910", label: "112910 - Apiculture" },
  { value: "112920", label: "112920 - Horses and Other Equine Production" },
  { value: "112930", label: "112930 - Fur-Bearing Animal and Rabbit Production" },
  { value: "112990", label: "112990 - All Other Animal Production" },
  { value: "113110", label: "113110 - Timber Tract Operations" },
  { value: "113210", label: "113210 - Forest Nurseries and Gathering of Forest Products" },
  { value: "113310", label: "113310 - Logging" },
  { value: "114111", label: "114111 - Finfish Fishing" },
  { value: "114112", label: "114112 - Shellfish Fishing" },
  { value: "114119", label: "114119 - Other Marine Fishing" },
  { value: "114210", label: "114210 - Hunting and Trapping" },
  { value: "115111", label: "115111 - Cotton Ginning" },
  { value: "115112", label: "115112 - Soil Preparation, Planting, and Cultivating" },
  { value: "115113", label: "115113 - Crop Harvesting, Primarily by Machine" },
  { value: "115114", label: "115114 - Postharvest Crop Activities (except Cotton Ginning)" },
  { value: "115115", label: "115115 - Farm Labor Contractors and Crew Leaders" },
  { value: "115116", label: "115116 - Farm Management Services" },
  { value: "115210", label: "115210 - Support Activities for Animal Production" },
  { value: "115310", label: "115310 - Support Activities for Forestry" },

  // Mining, Quarrying, and Oil and Gas Extraction
  { value: "211120", label: "211120 - Crude Petroleum Extraction" },
  { value: "211130", label: "211130 - Natural Gas Extraction" },
  { value: "212114", label: "212114 - Surface Coal Mining" },
  { value: "212115", label: "212115 - Underground Coal Mining" },
  { value: "212210", label: "212210 - Iron Ore Mining" },
  { value: "212220", label: "212220 - Gold Ore and Silver Ore Mining" },
  { value: "212230", label: "212230 - Copper, Nickel, Lead, and Zinc Mining" },
  { value: "212290", label: "212290 - Other Metal Ore Mining" },
  { value: "212311", label: "212311 - Dimension Stone Mining and Quarrying" },
  { value: "212312", label: "212312 - Crushed and Broken Limestone Mining and Quarrying" },
  { value: "212313", label: "212313 - Crushed and Broken Granite Mining and Quarrying" },
  { value: "212319", label: "212319 - Other Crushed and Broken Stone Mining and Quarrying" },
  { value: "212321", label: "212321 - Construction Sand and Gravel Mining" },
  { value: "212322", label: "212322 - Industrial Sand Mining" },
  { value: "212323", label: "212323 - Kaolin, Clay, and Ceramic and Refractory Minerals Mining" },
  { value: "212390", label: "212390 - Other Nonmetallic Mineral Mining and Quarrying" },
  { value: "213111", label: "213111 - Drilling Oil and Gas Wells" },
  { value: "213112", label: "213112 - Support Activities for Oil and Gas Operations" },
  { value: "213113", label: "213113 - Support Activities for Coal Mining" },
  { value: "213114", label: "213114 - Support Activities for Metal Mining" },
  { value: "213115", label: "213115 - Support Activities for Nonmetallic Minerals (except Fuels) Mining" },

  // Utilities
  { value: "221111", label: "221111 - Hydroelectric Power Generation" },
  { value: "221112", label: "221112 - Fossil Fuel Electric Power Generation" },
  { value: "221113", label: "221113 - Nuclear Electric Power Generation" },
  { value: "221114", label: "221114 - Solar Electric Power Generation" },
  { value: "221115", label: "221115 - Wind Electric Power Generation" },
  { value: "221116", label: "221116 - Geothermal Electric Power Generation" },
  { value: "221117", label: "221117 - Biomass Electric Power Generation" },
  { value: "221118", label: "221118 - Other Electric Power Generation" },
  { value: "221121", label: "221121 - Electric Bulk Power Transmission and Control" },
  { value: "221122", label: "221122 - Electric Power Distribution" },
  { value: "221210", label: "221210 - Natural Gas Distribution" },
  { value: "221310", label: "221310 - Water Supply and Irrigation Systems" },
  { value: "221320", label: "221320 - Sewage Treatment Facilities" },
  { value: "221330", label: "221330 - Steam and Air-Conditioning Supply" },

  // Construction
  { value: "236115", label: "236115 - New Single-Family Housing Construction (except For-Sale Builders)" },
  { value: "236116", label: "236116 - New Multifamily Housing Construction (except For-Sale Builders)" },
  { value: "236117", label: "236117 - New Housing For-Sale Builders" },
  { value: "236118", label: "236118 - Residential Remodelers" },
  { value: "236210", label: "236210 - Industrial Building Construction" },
  { value: "236220", label: "236220 - Commercial and Institutional Building Construction" },
  { value: "237110", label: "237110 - Water and Sewer Line and Related Structures Construction" },
  { value: "237120", label: "237120 - Oil and Gas Pipeline and Related Structures Construction" },
  { value: "237130", label: "237130 - Power and Communication Line and Related Structures Construction" },
  { value: "237210", label: "237210 - Land Subdivision" },
  { value: "237310", label: "237310 - Highway, Street, and Bridge Construction" },
  { value: "237990", label: "237990 - Other Heavy and Civil Engineering Construction" },
  { value: "238110", label: "238110 - Poured Concrete Foundation and Structure Contractors" },
  { value: "238120", label: "238120 - Structural Steel and Precast Concrete Contractors" },
  { value: "238130", label: "238130 - Framing Contractors" },
  { value: "238140", label: "238140 - Masonry Contractors" },
  { value: "238150", label: "238150 - Glass and Glazing Contractors" },
  { value: "238160", label: "238160 - Roofing Contractors" },
  { value: "238170", label: "238170 - Siding Contractors" },
  { value: "238190", label: "238190 - Other Foundation, Structure, and Building Exterior Contractors" },
  { value: "238210", label: "238210 - Electrical Contractors and Other Wiring Installation Contractors" },
  { value: "238220", label: "238220 - Plumbing, Heating, and Air-Conditioning Contractors" },
  { value: "238290", label: "238290 - Other Building Equipment Contractors" },
  { value: "238310", label: "238310 - Drywall and Insulation Contractors" },
  { value: "238320", label: "238320 - Painting and Wall Covering Contractors" },
  { value: "238330", label: "238330 - Flooring Contractors" },
  { value: "238340", label: "238340 - Tile and Terrazzo Contractors" },
  { value: "238350", label: "238350 - Finish Carpentry Contractors" },
  { value: "238390", label: "238390 - Other Building Finishing Contractors" },
  { value: "238910", label: "238910 - Site Preparation Contractors" },
  { value: "238990", label: "238990 - All Other Specialty Trade Contractors" },

  // Manufacturing
  { value: "311111", label: "311111 - Dog and Cat Food Manufacturing" },
  { value: "311119", label: "311119 - Other Animal Food Manufacturing" },
  { value: "311211", label: "311211 - Flour Milling" },
  { value: "311212", label: "311212 - Rice Milling" },
  { value: "311213", label: "311213 - Malt Manufacturing" },
  { value: "311221", label: "311221 - Wet Corn Milling and Starch Manufacturing" },
  { value: "311224", label: "311224 - Soybean and Other Oilseed Processing" },
  { value: "311225", label: "311225 - Fats and Oils Refining and Blending" },
  { value: "311230", label: "311230 - Breakfast Cereal Manufacturing" },
  { value: "311313", label: "311313 - Beet Sugar Manufacturing" },
  { value: "311314", label: "311314 - Cane Sugar Manufacturing" },
  { value: "311340", label: "311340 - Nonchocolate Confectionery Manufacturing" },
  { value: "311351", label: "311351 - Chocolate and Confectionery Manufacturing from Cacao Beans" },
  { value: "311352", label: "311352 - Confectionery Manufacturing from Purchased Chocolate" },
  { value: "311411", label: "311411 - Frozen Fruit, Juice, and Vegetable Manufacturing" },
  { value: "311412", label: "311412 - Frozen Specialty Food Manufacturing" },
  { value: "311421", label: "311421 - Fruit and Vegetable Canning" },
  { value: "311422", label: "311422 - Specialty Canning" },
  { value: "311423", label: "311423 - Dried and Dehydrated Food Manufacturing" },
  { value: "311511", label: "311511 - Fluid Milk Manufacturing" },
  { value: "311512", label: "311512 - Creamery Butter Manufacturing" },
  { value: "311513", label: "311513 - Cheese Manufacturing" },
  { value: "311514", label: "311514 - Dry, Condensed, and Evaporated Dairy Product Manufacturing" },
  { value: "311520", label: "311520 - Ice Cream and Frozen Dessert Manufacturing" },
  { value: "311611", label: "311611 - Animal (except Poultry) Slaughtering" },
  { value: "311612", label: "311612 - Meat Processed from Carcasses" },
  { value: "311613", label: "311613 - Rendering and Meat Byproduct Processing" },
  { value: "311615", label: "311615 - Poultry Processing" },
  { value: "311710", label: "311710 - Seafood Product Preparation and Packaging" },
  { value: "311811", label: "311811 - Retail Bakeries" },
  { value: "311812", label: "311812 - Commercial Bakeries" },
  { value: "311813", label: "311813 - Frozen Cakes, Pies, and Other Pastries Manufacturing" },
  { value: "311821", label: "311821 - Cookie and Cracker Manufacturing" },
  { value: "311824", label: "311824 - Dry Pasta, Dough, and Flour Mixes Manufacturing from Purchased Flour" },
  { value: "311830", label: "311830 - Tortilla Manufacturing" },
  { value: "311911", label: "311911 - Roasted Nuts and Peanut Butter Manufacturing" },
  { value: "311919", label: "311919 - Other Snack Food Manufacturing" },
  { value: "311920", label: "311920 - Coffee and Tea Manufacturing" },
  { value: "311930", label: "311930 - Flavoring Syrup and Concentrate Manufacturing" },
  { value: "311941", label: "311941 - Mayonnaise, Dressing, and Other Prepared Sauce Manufacturing" },
  { value: "311942", label: "311942 - Spice and Extract Manufacturing" },
  { value: "311991", label: "311991 - Perishable Prepared Food Manufacturing" },
  { value: "311999", label: "311999 - All Other Miscellaneous Food Manufacturing" },
  { value: "312111", label: "312111 - Soft Drink Manufacturing" },
  { value: "312112", label: "312112 - Bottled Water Manufacturing" },
  { value: "312113", label: "312113 - Ice Manufacturing" },
  { value: "312120", label: "312120 - Breweries" },
  { value: "312130", label: "312130 - Wineries" },
  { value: "312140", label: "312140 - Distilleries" },
  { value: "312230", label: "312230 - Tobacco Manufacturing" },
  { value: "313110", label: "313110 - Fiber, Yarn, and Thread Mills" },
  { value: "313210", label: "313210 - Broadwoven Fabric Mills" },
  { value: "313220", label: "313220 - Narrow Fabric Mills and Schiffli Machine Embroidery" },
  { value: "313230", label: "313230 - Nonwoven Fabric Mills" },
  { value: "313240", label: "313240 - Knit Fabric Mills" },
  { value: "313310", label: "313310 - Textile and Fabric Finishing Mills" },
  { value: "313320", label: "313320 - Fabric Coating Mills" },
  { value: "314110", label: "314110 - Carpet and Rug Mills" },
  { value: "314120", label: "314120 - Curtain and Linen Mills" },
  { value: "314910", label: "314910 - Textile Bag and Canvas Mills" },
  { value: "314994", label: "314994 - Rope, Cordage, Twine, Tire Cord, and Tire Fabric Mills" },
  { value: "314999", label: "314999 - All Other Miscellaneous Textile Product Mills" },
  { value: "315120", label: "315120 - Apparel Knitting Mills" },
  { value: "315210", label: "315210 - Cut and Sew Apparel Contractors" },
  { value: "315250", label: "315250 - Cut and Sew Apparel Manufacturing (except Contractors)" },
  { value: "315990", label: "315990 - Apparel Accessories and Other Apparel Manufacturing" },
  { value: "316110", label: "316110 - Leather and Hide Tanning and Finishing" },
  { value: "316210", label: "316210 - Footwear Manufacturing" },
  { value: "316990", label: "316990 - Other Leather and Allied Product Manufacturing" },
  { value: "321113", label: "321113 - Sawmills" },
  { value: "321114", label: "321114 - Wood Preservation" },
  { value: "321211", label: "321211 - Hardwood Veneer and Plywood Manufacturing" },
  { value: "321212", label: "321212 - Softwood Veneer and Plywood Manufacturing" },
  { value: "321215", label: "321215 - Engineered Wood Member Manufacturing" },
  { value: "321219", label: "321219 - Reconstituted Wood Product Manufacturing" },
  { value: "321911", label: "321911 - Wood Window and Door Manufacturing" },
  { value: "321912", label: "321912 - Cut Stock, Resawing Lumber, and Planing" },
  { value: "321918", label: "321918 - Other Millwork (including Flooring)" },
  { value: "321920", label: "321920 - Wood Container and Pallet Manufacturing" },
  { value: "321991", label: "321991 - Manufactured Home (Mobile Home) Manufacturing" },
  { value: "321992", label: "321992 - Prefabricated Wood Building Manufacturing" },
  { value: "321999", label: "321999 - All Other Miscellaneous Wood Product Manufacturing" },
  { value: "322110", label: "322110 - Pulp Mills" },
  { value: "322120", label: "322120 - Paper Mills" },
  { value: "322130", label: "322130 - Paperboard Mills" },
  { value: "322211", label: "322211 - Corrugated and Solid Fiber Box Manufacturing" },
  { value: "322212", label: "322212 - Folding Paperboard Box Manufacturing" },
  { value: "322219", label: "322219 - Other Paperboard Container Manufacturing" },
  { value: "322220", label: "322220 - Paper Bag and Coated and Treated Paper Manufacturing" },
  { value: "322230", label: "322230 - Stationery Product Manufacturing" },
  { value: "322291", label: "322291 - Sanitary Paper Product Manufacturing" },
  { value: "322299", label: "322299 - All Other Converted Paper Product Manufacturing" },
  { value: "323111", label: "323111 - Commercial Printing (except Screen and Books)" },
  { value: "323113", label: "323113 - Commercial Screen Printing" },
  { value: "323117", label: "323117 - Books Printing" },
  { value: "323120", label: "323120 - Support Activities for Printing" },
  { value: "324110", label: "324110 - Petroleum Refineries" },
  { value: "324121", label: "324121 - Asphalt Paving Mixture and Block Manufacturing" },
  { value: "324122", label: "324122 - Asphalt Shingle and Coating Materials Manufacturing" },
  { value: "324191", label: "324191 - Petroleum Lubricating Oil and Grease Manufacturing" },
  { value: "324199", label: "324199 - All Other Petroleum and Coal Products Manufacturing" },
  { value: "325110", label: "325110 - Petrochemical Manufacturing" },
  { value: "325120", label: "325120 - Industrial Gas Manufacturing" },
  { value: "325130", label: "325130 - Synthetic Dye and Pigment Manufacturing" },
  { value: "325180", label: "325180 - Other Basic Inorganic Chemical Manufacturing" },
  { value: "325193", label: "325193 - Ethyl Alcohol Manufacturing" },
  { value: "325194", label: "325194 - Cyclic Crude, Intermediate, and Gum and Wood Chemical Manufacturing" },
  { value: "325199", label: "325199 - All Other Basic Organic Chemical Manufacturing" },
  { value: "325211", label: "325211 - Plastics Material and Resin Manufacturing" },
  { value: "325212", label: "325212 - Synthetic Rubber Manufacturing" },
  { value: "325220", label: "325220 - Artificial and Synthetic Fibers and Filaments Manufacturing" },
  { value: "325311", label: "325311 - Nitrogenous Fertilizer Manufacturing" },
  { value: "325312", label: "325312 - Phosphatic Fertilizer Manufacturing" },
  { value: "325314", label: "325314 - Fertilizer (Mixing Only) Manufacturing" },
  { value: "325315", label: "325315 - Compost Manufacturing" },
  { value: "325320", label: "325320 - Pesticide and Other Agricultural Chemical Manufacturing" },
  { value: "325411", label: "325411 - Medicinal and Botanical Manufacturing" },
  { value: "325412", label: "325412 - Pharmaceutical Preparation Manufacturing" },
  { value: "325413", label: "325413 - In-Vitro Diagnostic Substance Manufacturing" },
  { value: "325414", label: "325414 - Biological Product (except Diagnostic) Manufacturing" },
  { value: "325510", label: "325510 - Paint and Coating Manufacturing" },
  { value: "325520", label: "325520 - Adhesive Manufacturing" },
  { value: "325611", label: "325611 - Soap and Other Detergent Manufacturing" },
  { value: "325612", label: "325612 - Polish and Other Sanitation Good Manufacturing" },
  { value: "325613", label: "325613 - Surface Active Agent Manufacturing" },
  { value: "325620", label: "325620 - Toilet Preparation Manufacturing" },
  { value: "325910", label: "325910 - Printing Ink Manufacturing" },
  { value: "325920", label: "325920 - Explosives Manufacturing" },
  { value: "325991", label: "325991 - Custom Compounding of Purchased Resins" },
  { value: "325992", label: "325992 - Photographic Film, Paper, Plate, Chemical, and Copy Toner Manufacturing" },
  { value: "325998", label: "325998 - All Other Miscellaneous Chemical Product and Preparation Manufacturing" },
  { value: "326111", label: "326111 - Plastics Bag and Pouch Manufacturing" },
  { value: "326112", label: "326112 - Plastics Packaging Film and Sheet (including Laminated) Manufacturing" },
  { value: "326113", label: "326113 - Unlaminated Plastics Film and Sheet (except Packaging) Manufacturing" },
  { value: "326121", label: "326121 - Unlaminated Plastics Profile Shape Manufacturing" },
  { value: "326122", label: "326122 - Plastics Pipe and Pipe Fitting Manufacturing" },
  { value: "326130", label: "326130 - Laminated Plastics Plate, Sheet (except Packaging), and Shape Manufacturing" },
  { value: "326140", label: "326140 - Polystyrene Foam Product Manufacturing" },
  { value: "326150", label: "326150 - Urethane and Other Foam Product (except Polystyrene) Manufacturing" },
  { value: "326160", label: "326160 - Plastics Bottle Manufacturing" },
  { value: "326191", label: "326191 - Plastics Plumbing Fixture Manufacturing" },
  { value: "326199", label: "326199 - All Other Plastics Product Manufacturing" },
  { value: "326211", label: "326211 - Tire Manufacturing (except Retreading)" },
  { value: "326212", label: "326212 - Tire Retreading" },
  { value: "326220", label: "326220 - Rubber and Plastics Hoses and Belting Manufacturing" },
  { value: "326291", label: "326291 - Rubber Product Manufacturing for Mechanical Use" },
  { value: "326299", label: "326299 - All Other Rubber Product Manufacturing" },
  { value: "327110", label: "327110 - Pottery, Ceramics, and Plumbing Fixture Manufacturing" },
  { value: "327120", label: "327120 - Clay Building Material and Refractories Manufacturing" },
  { value: "327211", label: "327211 - Flat Glass Manufacturing" },
  { value: "327212", label: "327212 - Other Pressed and Blown Glass and Glassware Manufacturing" },
  { value: "327213", label: "327213 - Glass Container Manufacturing" },
  { value: "327215", label: "327215 - Glass Product Manufacturing Made of Purchased Glass" },
  { value: "327310", label: "327310 - Cement Manufacturing" },
  { value: "327320", label: "327320 - Ready-Mix Concrete Manufacturing" },
  { value: "327331", label: "327331 - Concrete Block and Brick Manufacturing" },
  { value: "327332", label: "327332 - Concrete Pipe Manufacturing" },
  { value: "327390", label: "327390 - Other Concrete Product Manufacturing" },
  { value: "327410", label: "327410 - Lime Manufacturing" },
  { value: "327420", label: "327420 - Gypsum Product Manufacturing" },
  { value: "327910", label: "327910 - Abrasive Product Manufacturing" },
  { value: "327991", label: "327991 - Cut Stone and Stone Product Manufacturing" },
  { value: "327992", label: "327992 - Ground or Treated Mineral and Earth Manufacturing" },
  { value: "327993", label: "327993 - Mineral Wool Manufacturing" },
  { value: "327999", label: "327999 - All Other Miscellaneous Nonmetallic Mineral Product Manufacturing" },
  { value: "331110", label: "331110 - Iron and Steel Mills and Ferroalloy Manufacturing" },
  { value: "331210", label: "331210 - Iron and Steel Pipe and Tube Manufacturing from Purchased Steel" },
  { value: "331221", label: "331221 - Rolled Steel Shape Manufacturing" },
  { value: "331222", label: "331222 - Steel Wire Drawing" },
  { value: "331313", label: "331313 - Alumina Refining and Primary Aluminum Production" },
  { value: "331314", label: "331314 - Secondary Smelting and Alloying of Aluminum" },
  { value: "331315", label: "331315 - Aluminum Sheet, Plate, and Foil Manufacturing" },
  { value: "331318", label: "331318 - Other Aluminum Rolling, Drawing, and Extruding" },
  { value: "331410", label: "331410 - Nonferrous Metal (except Aluminum) Smelting and Refining" },
  { value: "331420", label: "331420 - Copper Rolling, Drawing, Extruding, and Alloying" },
  { value: "331491", label: "331491 - Nonferrous Metal (except Copper and Aluminum) Rolling, Drawing, and Extruding" },
  { value: "331492", label: "331492 - Secondary Smelting, Refining, and Alloying of Nonferrous Metal (except Copper and Aluminum)" },
  { value: "331511", label: "331511 - Iron Foundries" },
  { value: "331512", label: "331512 - Steel Investment Foundries" },
  { value: "331513", label: "331513 - Steel Foundries (except Investment)" },
  { value: "331523", label: "331523 - Nonferrous Metal Die-Casting Foundries" },
  { value: "331524", label: "331524 - Aluminum Foundries (except Die-Casting)" },
  { value: "331529", label: "331529 - Other Nonferrous Metal Foundries (except Die-Casting)" },
  { value: "332111", label: "332111 - Iron and Steel Forging" },
  { value: "332112", label: "332112 - Nonferrous Forging" },
  { value: "332114", label: "332114 - Custom Roll Forming" },
  { value: "332117", label: "332117 - Powder Metallurgy Part Manufacturing" },
  { value: "332119", label: "332119 - Metal Crown, Closure, and Other Metal Stamping (except Automotive)" },
  { value: "332215", label: "332215 - Metal Kitchen Cookware, Utensil, Cutlery, and Flatware (except Precious) Manufacturing" },
  { value: "332216", label: "332216 - Saw Blade and Handtool Manufacturing" },
  { value: "332311", label: "332311 - Prefabricated Metal Building and Component Manufacturing" },
  { value: "332312", label: "332312 - Fabricated Structural Metal Manufacturing" },
  { value: "332313", label: "332313 - Plate Work Manufacturing" },
  { value: "332321", label: "332321 - Metal Window and Door Manufacturing" },
  { value: "332322", label: "332322 - Sheet Metal Work Manufacturing" },
  { value: "332323", label: "332323 - Ornamental and Architectural Metal Work Manufacturing" },
  { value: "332410", label: "332410 - Power Boiler and Heat Exchanger Manufacturing" },
  { value: "332420", label: "332420 - Metal Tank (Heavy Gauge) Manufacturing" },
  { value: "332431", label: "332431 - Metal Can Manufacturing" },
  { value: "332439", label: "332439 - Other Metal Container Manufacturing" },
  { value: "332510", label: "332510 - Hardware Manufacturing" },
  { value: "332613", label: "332613 - Spring Manufacturing" },
  { value: "332618", label: "332618 - Other Fabricated Wire Product Manufacturing" },
  { value: "332710", label: "332710 - Machine Shops" },
  { value: "332721", label: "332721 - Precision Turned Product Manufacturing" },
  { value: "332722", label: "332722 - Bolt, Nut, Screw, Rivet, and Washer Manufacturing" },
  { value: "332811", label: "332811 - Metal Heat Treating" },
  { value: "332812", label: "332812 - Metal Coating, Engraving (except Jewelry and Silverware), and Allied Services to Manufacturers" },
  { value: "332813", label: "332813 - Electroplating, Plating, Polishing, Anodizing, and Coloring" },
  { value: "332911", label: "332911 - Industrial Valve Manufacturing" },
  { value: "332912", label: "332912 - Fluid Power Valve and Hose Fitting Manufacturing" },
  { value: "332913", label: "332913 - Plumbing Fixture Fitting and Trim Manufacturing" },
  { value: "332919", label: "332919 - Other Metal Valve and Pipe Fitting Manufacturing" },
  { value: "332991", label: "332991 - Ball and Roller Bearing Manufacturing" },
  { value: "332992", label: "332992 - Small Arms Ammunition Manufacturing" },
  { value: "332993", label: "332993 - Ammunition (except Small Arms) Manufacturing" },
  { value: "332994", label: "332994 - Small Arms, Ordnance, and Ordnance Accessories Manufacturing" },
  { value: "332996", label: "332996 - Fabricated Pipe and Pipe Fitting Manufacturing" },
  { value: "332999", label: "332999 - All Other Miscellaneous Fabricated Metal Product Manufacturing" },
  { value: "333111", label: "333111 - Farm Machinery and Equipment Manufacturing" },
  { value: "333112", label: "333112 - Lawn and Garden Tractor and Home Lawn and Garden Equipment Manufacturing" },
  { value: "333120", label: "333120 - Construction Machinery Manufacturing" },
  { value: "333131", label: "333131 - Mining Machinery and Equipment Manufacturing" },
  { value: "333132", label: "333132 - Oil and Gas Field Machinery and Equipment Manufacturing" },
  { value: "333241", label: "333241 - Food Product Machinery Manufacturing" },
  { value: "333242", label: "333242 - Semiconductor Machinery Manufacturing" },
  { value: "333243", label: "333243 - Sawmill, Woodworking, and Paper Machinery Manufacturing" },
  { value: "333248", label: "333248 - All Other Industrial Machinery Manufacturing" },
  { value: "333310", label: "333310 - Commercial and Service Industry Machinery Manufacturing" },
  { value: "333413", label: "333413 - Industrial and Commercial Fan and Blower and Air Purification Equipment Manufacturing" },
  { value: "333414", label: "333414 - Heating Equipment (except Warm Air Furnaces) Manufacturing" },
  { value: "333415", label: "333415 - Air-Conditioning and Warm Air Heating Equipment and Commercial and Industrial Refrigeration Equipment Manufacturing" },
  { value: "333511", label: "333511 - Industrial Mold Manufacturing" },
  { value: "333514", label: "333514 - Special Die and Tool, Die Set, Jig, and Fixture Manufacturing" },
  { value: "333515", label: "333515 - Cutting Tool and Machine Tool Accessory Manufacturing" },
  { value: "333517", label: "333517 - Machine Tool Manufacturing" },
  { value: "333519", label: "333519 - Rolling Mill and Other Metalworking Machinery Manufacturing" },
  { value: "333611", label: "333611 - Turbine and Turbine Generator Set Units Manufacturing" },
  { value: "333612", label: "333612 - Speed Changer, Industrial High-Speed Drive, and Gear Manufacturing" },
  { value: "333613", label: "333613 - Mechanical Power Transmission Equipment Manufacturing" },
  { value: "333618", label: "333618 - Other Engine Equipment Manufacturing" },
  { value: "333912", label: "333912 - Air and Gas Compressor Manufacturing" },
  { value: "333914", label: "333914 - Measuring, Dispensing, and Other Pumping Equipment Manufacturing" },
  { value: "333921", label: "333921 - Elevator and Moving Stairway Manufacturing" },
  { value: "333922", label: "333922 - Conveyor and Conveying Equipment Manufacturing" },
  { value: "333923", label: "333923 - Overhead Traveling Crane, Hoist, and Monorail System Manufacturing" },
  { value: "333924", label: "333924 - Industrial Truck, Tractor, Trailer, and Stacker Machinery Manufacturing" },
  { value: "333991", label: "333991 - Power-Driven Handtool Manufacturing" },
  { value: "333992", label: "333992 - Welding and Soldering Equipment Manufacturing" },
  { value: "333993", label: "333993 - Packaging Machinery Manufacturing" },
  { value: "333994", label: "333994 - Industrial Process Furnace and Oven Manufacturing" },
  { value: "333995", label: "333995 - Fluid Power Cylinder and Actuator Manufacturing" },
  { value: "333996", label: "333996 - Fluid Power Pump and Motor Manufacturing" },
  { value: "333998", label: "333998 - All Other Miscellaneous General Purpose Machinery Manufacturing" },
  { value: "334111", label: "334111 - Electronic Computer Manufacturing" },
  { value: "334112", label: "334112 - Computer Storage Device Manufacturing" },
  { value: "334118", label: "334118 - Computer Terminal and Other Computer Peripheral Equipment Manufacturing" },
  { value: "334210", label: "334210 - Telephone Apparatus Manufacturing" },
  { value: "334220", label: "334220 - Radio and Television Broadcasting and Wireless Communications Equipment Manufacturing" },
  { value: "334290", label: "334290 - Other Communications Equipment Manufacturing" },
  { value: "334310", label: "334310 - Audio and Video Equipment Manufacturing" },
  { value: "334412", label: "334412 - Bare Printed Circuit Board Manufacturing" },
  { value: "334413", label: "334413 - Semiconductor and Related Device Manufacturing" },
  { value: "334416", label: "334416 - Capacitor, Resistor, Coil, Transformer, and Other Inductor Manufacturing" },
  { value: "334417", label: "334417 - Electronic Connector Manufacturing" },
  { value: "334418", label: "334418 - Printed Circuit Assembly (Electronic Assembly) Manufacturing" },
  { value: "334419", label: "334419 - Other Electronic Component Manufacturing" },
  { value: "334510", label: "334510 - Electromedical and Electrotherapeutic Apparatus Manufacturing" },
  { value: "334511", label: "334511 - Search, Detection, Navigation, Guidance, Aeronautical, and Nautical System and Instrument Manufacturing" },
  { value: "334512", label: "334512 - Automatic Environmental Control Manufacturing for Residential, Commercial, and Appliance Use" },
  { value: "334513", label: "334513 - Instruments and Related Products Manufacturing for Measuring, Displaying, and Controlling Industrial Process Variables" },
  { value: "334514", label: "334514 - Totalizing Fluid Meter and Counting Device Manufacturing" },
  { value: "334515", label: "334515 - Instrument Manufacturing for Measuring and Testing Electricity and Electrical Signals" },
  { value: "334516", label: "334516 - Analytical Laboratory Instrument Manufacturing" },
  { value: "334517", label: "334517 - Irradiation Apparatus Manufacturing" },
  { value: "334519", label: "334519 - Other Measuring and Controlling Device Manufacturing" },
  { value: "334610", label: "334610 - Manufacturing and Reproducing Magnetic and Optical Media" },
  { value: "335131", label: "335131 - Residential Electric Lighting Fixture Manufacturing" },
  { value: "335132", label: "335132 - Commercial, Industrial, and Institutional Electric Lighting Fixture Manufacturing" },
  { value: "335139", label: "335139 - Electric Lamp Bulb and Other Lighting Equipment Manufacturing" },
  { value: "335210", label: "335210 - Small Electrical Appliance Manufacturing" },
  { value: "335220", label: "335220 - Major Household Appliance Manufacturing" },
  { value: "335311", label: "335311 - Power, Distribution, and Specialty Transformer Manufacturing" },
  { value: "335312", label: "335312 - Motor and Generator Manufacturing" },
  { value: "335313", label: "335313 - Switchgear and Switchboard Apparatus Manufacturing" },
  { value: "335314", label: "335314 - Relay and Industrial Control Manufacturing" },
  { value: "335910", label: "335910 - Battery Manufacturing" },
  { value: "335921", label: "335921 - Fiber Optic Cable Manufacturing" },
  { value: "335929", label: "335929 - Other Communication and Energy Wire Manufacturing" },
  { value: "335931", label: "335931 - Current-Carrying Wiring Device Manufacturing" },
  { value: "335932", label: "335932 - Noncurrent-Carrying Wiring Device Manufacturing" },
  { value: "335991", label: "335991 - Carbon and Graphite Product Manufacturing" },
  { value: "335999", label: "335999 - All Other Miscellaneous Electrical Equipment and Component Manufacturing" },
  { value: "336110", label: "336110 - Automobile and Light Duty Motor Vehicle Manufacturing" },
  { value: "336120", label: "336120 - Heavy Duty Truck Manufacturing" },
  { value: "336211", label: "336211 - Motor Vehicle Body Manufacturing" },
  { value: "336212", label: "336212 - Truck Trailer Manufacturing" },
  { value: "336213", label: "336213 - Motor Home Manufacturing" },
  { value: "336214", label: "336214 - Travel Trailer and Camper Manufacturing" },
  { value: "336310", label: "336310 - Motor Vehicle Gasoline Engine and Engine Parts Manufacturing" },
  { value: "336320", label: "336320 - Motor Vehicle Electrical and Electronic Equipment Manufacturing" },
  { value: "336330", label: "336330 - Motor Vehicle Steering and Suspension Components (except Spring) Manufacturing" },
  { value: "336340", label: "336340 - Motor Vehicle Brake System Manufacturing" },
  { value: "336350", label: "336350 - Motor Vehicle Transmission and Power Train Parts Manufacturing" },
  { value: "336360", label: "336360 - Motor Vehicle Seating and Interior Trim Manufacturing" },
  { value: "336370", label: "336370 - Motor Vehicle Metal Stamping" },
  { value: "336390", label: "336390 - Other Motor Vehicle Parts Manufacturing" },
  { value: "336411", label: "336411 - Aircraft Manufacturing" },
  { value: "336412", label: "336412 - Aircraft Engine and Engine Parts Manufacturing" },
  { value: "336413", label: "336413 - Other Aircraft Parts and Auxiliary Equipment Manufacturing" },
  { value: "336414", label: "336414 - Guided Missile and Space Vehicle Manufacturing" },
  { value: "336415", label: "336415 - Guided Missile and Space Vehicle Propulsion Unit and Propulsion Unit Parts Manufacturing" },
  { value: "336419", label: "336419 - Other Guided Missile and Space Vehicle Parts and Auxiliary Equipment Manufacturing" },
  { value: "336510", label: "336510 - Railroad Rolling Stock Manufacturing" },
  { value: "336611", label: "336611 - Ship Building and Repairing" },
  { value: "336612", label: "336612 - Boat Building" },
  { value: "336991", label: "336991 - Motorcycle, Bicycle, and Parts Manufacturing" },
  { value: "336992", label: "336992 - Military Armored Vehicle, Tank, and Tank Component Manufacturing" },
  { value: "336999", label: "336999 - All Other Transportation Equipment Manufacturing" },
  { value: "337110", label: "337110 - Wood Kitchen Cabinet and Countertop Manufacturing" },
  { value: "337121", label: "337121 - Upholstered Household Furniture Manufacturing" },
  { value: "337122", label: "337122 - Nonupholstered Wood Household Furniture Manufacturing" },
  { value: "337126", label: "337126 - Household Furniture (except Wood and Upholstered) Manufacturing" },
  { value: "337127", label: "337127 - Institutional Furniture Manufacturing" },
  { value: "337211", label: "337211 - Wood Office Furniture Manufacturing" },
  { value: "337212", label: "337212 - Custom Architectural Woodwork and Millwork Manufacturing" },
  { value: "337214", label: "337214 - Office Furniture (except Wood) Manufacturing" },
  { value: "337215", label: "337215 - Showcase, Partition, Shelving, and Locker Manufacturing" },
  { value: "337910", label: "337910 - Mattress Manufacturing" },
  { value: "337920", label: "337920 - Blind and Shade Manufacturing" },
  { value: "339112", label: "339112 - Surgical and Medical Instrument Manufacturing" },
  { value: "339113", label: "339113 - Surgical Appliance and Supplies Manufacturing" },
  { value: "339114", label: "339114 - Dental Equipment and Supplies Manufacturing" },
  { value: "339115", label: "339115 - Ophthalmic Goods Manufacturing" },
  { value: "339116", label: "339116 - Dental Laboratories" },
  { value: "339910", label: "339910 - Jewelry and Silverware Manufacturing" },
  { value: "339920", label: "339920 - Sporting and Athletic Goods Manufacturing" },
  { value: "339930", label: "339930 - Doll, Toy, and Game Manufacturing" },
  { value: "339940", label: "339940 - Office Supplies (except Paper) Manufacturing" },
  { value: "339950", label: "339950 - Sign Manufacturing" },
  { value: "339991", label: "339991 - Gasket, Packing, and Sealing Device Manufacturing" },
  { value: "339992", label: "339992 - Musical Instrument Manufacturing" },
  { value: "339993", label: "339993 - Fastener, Button, Needle, and Pin Manufacturing" },
  { value: "339994", label: "339994 - Broom, Brush, and Mop Manufacturing" },
  { value: "339995", label: "339995 - Burial Casket Manufacturing" },
  { value: "339999", label: "339999 - All Other Miscellaneous Manufacturing" },

  // Wholesale Trade
  { value: "423110", label: "423110 - Automobile and Other Motor Vehicle Merchant Wholesalers" },
  { value: "423120", label: "423120 - Motor Vehicle Supplies and New Parts Merchant Wholesalers" },
  { value: "423130", label: "423130 - Tire and Tube Merchant Wholesalers" },
  { value: "423140", label: "423140 - Motor Vehicle Parts (Used) Merchant Wholesalers" },
  { value: "423210", label: "423210 - Furniture Merchant Wholesalers" },
  { value: "423220", label: "423220 - Home Furnishing Merchant Wholesalers" },
  { value: "423310", label: "423310 - Lumber, Plywood, Millwork, and Wood Panel Merchant Wholesalers" },
  { value: "423320", label: "423320 - Brick, Stone, and Related Construction Material Merchant Wholesalers" },
  { value: "423330", label: "423330 - Roofing, Siding, and Insulation Material Merchant Wholesalers" },
  { value: "423390", label: "423390 - Other Construction Material Merchant Wholesalers" },
  { value: "423410", label: "423410 - Photographic Equipment and Supplies Merchant Wholesalers" },
  { value: "423420", label: "423420 - Office Equipment Merchant Wholesalers" },
  { value: "423430", label: "423430 - Computer and Computer Peripheral Equipment and Software Merchant Wholesalers" },
  { value: "423440", label: "423440 - Other Commercial Equipment Merchant Wholesalers" },
  { value: "423450", label: "423450 - Medical, Dental, and Hospital Equipment and Supplies Merchant Wholesalers" },
  { value: "423460", label: "423460 - Ophthalmic Goods Merchant Wholesalers" },
  { value: "423490", label: "423490 - Other Professional Equipment and Supplies Merchant Wholesalers" },
  { value: "423510", label: "423510 - Metal Service Centers and Other Metal Merchant Wholesalers" },
  { value: "423520", label: "423520 - Coal and Other Mineral and Ore Merchant Wholesalers" },
  { value: "423610", label: "423610 - Electrical Apparatus and Equipment, Wiring Supplies, and Related Equipment Merchant Wholesalers" },
  { value: "423620", label: "423620 - Household Appliances, Electric Housewares, and Consumer Electronics Merchant Wholesalers" },
  { value: "423690", label: "423690 - Other Electronic Parts and Equipment Merchant Wholesalers" },
  { value: "423710", label: "423710 - Hardware Merchant Wholesalers" },
  { value: "423720", label: "423720 - Plumbing and Heating Equipment and Supplies (Hydronics) Merchant Wholesalers" },
  { value: "423730", label: "423730 - Warm Air Heating and Air-Conditioning Equipment and Supplies Merchant Wholesalers" },
  { value: "423740", label: "423740 - Refrigeration Equipment and Supplies Merchant Wholesalers" },
  { value: "423810", label: "423810 - Construction and Mining (except Oil Well) Machinery and Equipment Merchant Wholesalers" },
  { value: "423820", label: "423820 - Farm and Garden Machinery and Equipment Merchant Wholesalers" },
  { value: "423830", label: "423830 - Industrial Machinery and Equipment Merchant Wholesalers" },
  { value: "423840", label: "423840 - Industrial Supplies Merchant Wholesalers" },
  { value: "423850", label: "423850 - Service Establishment Equipment and Supplies Merchant Wholesalers" },
  { value: "423860", label: "423860 - Transportation Equipment and Supplies (except Motor Vehicle) Merchant Wholesalers" },
  { value: "423910", label: "423910 - Sporting and Recreational Goods and Supplies Merchant Wholesalers" },
  { value: "423920", label: "423920 - Toy and Hobby Goods and Supplies Merchant Wholesalers" },
  { value: "423930", label: "423930 - Recyclable Material Merchant Wholesalers" },
  { value: "423940", label: "423940 - Jewelry, Watch, Precious Stone, and Precious Metal Merchant Wholesalers" },
  { value: "423990", label: "423990 - Other Miscellaneous Durable Goods Merchant Wholesalers" },
  { value: "424110", label: "424110 - Printing and Writing Paper Merchant Wholesalers" },
  { value: "424120", label: "424120 - Stationery and Office Supplies Merchant Wholesalers" },
  { value: "424130", label: "424130 - Industrial and Personal Service Paper Merchant Wholesalers" },
  { value: "424210", label: "424210 - Drugs and Druggists' Sundries Merchant Wholesalers" },
  { value: "424310", label: "424310 - Piece Goods, Notions, and Other Dry Goods Merchant Wholesalers" },
  { value: "424340", label: "424340 - Footwear Merchant Wholesalers" },
  { value: "424350", label: "424350 - Clothing and Clothing Accessories Merchant Wholesalers" },
  { value: "424410", label: "424410 - General Line Grocery Merchant Wholesalers" },
  { value: "424420", label: "424420 - Packaged Frozen Food Merchant Wholesalers" },
  { value: "424430", label: "424430 - Dairy Product (except Dried or Canned) Merchant Wholesalers" },
  { value: "424440", label: "424440 - Poultry and Poultry Product Merchant Wholesalers" },
  { value: "424450", label: "424450 - Confectionery Merchant Wholesalers" },
  { value: "424460", label: "424460 - Fish and Seafood Merchant Wholesalers" },
  { value: "424470", label: "424470 - Meat and Meat Product Merchant Wholesalers" },
  { value: "424480", label: "424480 - Fresh Fruit and Vegetable Merchant Wholesalers" },
  { value: "424490", label: "424490 - Other Grocery and Related Products Merchant Wholesalers" },
  { value: "424510", label: "424510 - Grain and Field Bean Merchant Wholesalers" },
  { value: "424520", label: "424520 - Livestock Merchant Wholesalers" },
  { value: "424590", label: "424590 - Other Farm Product Raw Material Merchant Wholesalers" },
  { value: "424610", label: "424610 - Plastics Materials and Basic Forms and Shapes Merchant Wholesalers" },
  { value: "424690", label: "424690 - Other Chemical and Allied Products Merchant Wholesalers" },
  { value: "424710", label: "424710 - Petroleum Bulk Stations and Terminals" },
  { value: "424720", label: "424720 - Petroleum and Petroleum Products Merchant Wholesalers (except Bulk Stations and Terminals)" },
  { value: "424810", label: "424810 - Beer and Ale Merchant Wholesalers" },
  { value: "424820", label: "424820 - Wine and Distilled Alcoholic Beverage Merchant Wholesalers" },
  { value: "424910", label: "424910 - Farm Supplies Merchant Wholesalers" },
  { value: "424920", label: "424920 - Book, Periodical, and Newspaper Merchant Wholesalers" },
  { value: "424930", label: "424930 - Flower, Nursery Stock, and Florists' Supplies Merchant Wholesalers" },
  { value: "424940", label: "424940 - Tobacco Product and Electronic Cigarette Merchant Wholesalers" },
  { value: "424950", label: "424950 - Paint, Varnish, and Supplies Merchant Wholesalers" },
  { value: "424990", label: "424990 - Other Miscellaneous Nondurable Goods Merchant Wholesalers" },
  { value: "425120", label: "425120 - Wholesale Trade Agents and Brokers" },

  // Retail Trade
  { value: "441110", label: "441110 - New Car Dealers" },
  { value: "441120", label: "441120 - Used Car Dealers" },
  { value: "441210", label: "441210 - Recreational Vehicle Dealers" },
  { value: "441222", label: "441222 - Boat Dealers" },
  { value: "441227", label: "441227 - Motorcycle, ATV, and All Other Motor Vehicle Dealers" },
  { value: "441330", label: "441330 - Automotive Parts and Accessories Retailers" },
  { value: "441340", label: "441340 - Tire Dealers" },
  { value: "444110", label: "444110 - Home Centers" },
  { value: "444120", label: "444120 - Paint and Wallpaper Retailers" },
  { value: "444140", label: "444140 - Hardware Retailers" },
  { value: "444180", label: "444180 - Other Building Material Dealers" },
  { value: "444230", label: "444230 - Outdoor Power Equipment Retailers" },
  { value: "444240", label: "444240 - Nursery, Garden Center, and Farm Supply Retailers" },
  { value: "445110", label: "445110 - Supermarkets and Other Grocery Retailers (except Convenience Retailers)" },
  { value: "445131", label: "445131 - Convenience Retailers" },
  { value: "445132", label: "445132 - Vending Machine Operators" },
  { value: "445230", label: "445230 - Fruit and Vegetable Retailers" },
  { value: "445240", label: "445240 - Meat Retailers" },
  { value: "445250", label: "445250 - Fish and Seafood Retailers" },
  { value: "445291", label: "445291 - Baked Goods Retailers" },
  { value: "445292", label: "445292 - Confectionery and Nut Retailers" },
  { value: "445298", label: "445298 - All Other Specialty Food Retailers" },
  { value: "445320", label: "445320 - Beer, Wine, and Liquor Retailers" },
  { value: "449110", label: "449110 - Furniture Retailers" },
  { value: "449121", label: "449121 - Floor Covering Retailers" },
  { value: "449122", label: "449122 - Window Treatment Retailers" },
  { value: "449129", label: "449129 - All Other Home Furnishings Retailers" },
  { value: "449210", label: "449210 - Electronics and Appliance Retailers" },
  { value: "455110", label: "455110 - Department Stores" },
  { value: "455211", label: "455211 - Warehouse Clubs and Supercenters" },
  { value: "455219", label: "455219 - All Other General Merchandise Retailers" },
  { value: "456110", label: "456110 - Pharmacies and Drug Retailers" },
  { value: "456120", label: "456120 - Cosmetics, Beauty Supplies, and Perfume Retailers" },
  { value: "456130", label: "456130 - Optical Goods Retailers" },
  { value: "456191", label: "456191 - Food (Health) Supplement Retailers" },
  { value: "456199", label: "456199 - All Other Health and Personal Care Retailers" },
  { value: "457110", label: "457110 - Gasoline Stations with Convenience Stores" },
  { value: "457120", label: "457120 - Other Gasoline Stations" },
  { value: "457210", label: "457210 - Fuel Dealers" },
  { value: "458110", label: "458110 - Clothing and Clothing Accessories Retailers" },
  { value: "458210", label: "458210 - Shoe Retailers" },
  { value: "458310", label: "458310 - Jewelry Retailers" },
  { value: "458320", label: "458320 - Luggage and Leather Goods Retailers" },
  { value: "459110", label: "459110 - Sporting Goods Retailers" },
  { value: "459120", label: "459120 - Hobby, Toy, and Game Retailers" },
  { value: "459130", label: "459130 - Sewing, Needlework, and Piece Goods Retailers" },
  { value: "459140", label: "459140 - Musical Instrument and Supplies Retailers" },
  { value: "459210", label: "459210 - Book Retailers and News Dealers" },
  { value: "459310", label: "459310 - Florists" },
  { value: "459410", label: "459410 - Office Supplies and Stationery Retailers" },
  { value: "459420", label: "459420 - Gift, Novelty, and Souvenir Retailers" },
  { value: "459510", label: "459510 - Used Merchandise Retailers" },
  { value: "459910", label: "459910 - Pet and Pet Supplies Retailers" },
  { value: "459920", label: "459920 - Art Dealers" },
  { value: "459930", label: "459930 - Manufactured (Mobile) Home Dealers" },
  { value: "459991", label: "459991 - Tobacco, Electronic Cigarette, and Other Smoking Supplies Retailers" },
  { value: "459999", label: "459999 - All Other Miscellaneous Retailers" },

  // Transportation and Warehousing
  { value: "481111", label: "481111 - Scheduled Passenger Air Transportation" },
  { value: "481112", label: "481112 - Scheduled Freight Air Transportation" },
  { value: "481211", label: "481211 - Nonscheduled Chartered Passenger Air Transportation" },
  { value: "481212", label: "481212 - Nonscheduled Chartered Freight Air Transportation" },
  { value: "481219", label: "481219 - Other Nonscheduled Air Transportation" },
  { value: "482111", label: "482111 - Line-Haul Railroads" },
  { value: "482112", label: "482112 - Short Line Railroads" },
  { value: "483111", label: "483111 - Deep Sea Freight Transportation" },
  { value: "483112", label: "483112 - Deep Sea Passenger Transportation" },
  { value: "483113", label: "483113 - Coastal and Great Lakes Freight Transportation" },
  { value: "483114", label: "483114 - Coastal and Great Lakes Passenger Transportation" },
  { value: "483211", label: "483211 - Inland Water Freight Transportation" },
  { value: "483212", label: "483212 - Inland Water Passenger Transportation" },
  { value: "484110", label: "484110 - General Freight Trucking, Local" },
  { value: "484121", label: "484121 - General Freight Trucking, Long-Distance, Truckload" },
  { value: "484122", label: "484122 - General Freight Trucking, Long-Distance, Less Than Truckload" },
  { value: "484210", label: "484210 - Used Household and Office Goods Moving" },
  { value: "484220", label: "484220 - Specialized Freight (except Used Goods) Trucking, Local" },
  { value: "484230", label: "484230 - Specialized Freight (except Used Goods) Trucking, Long-Distance" },
  { value: "485111", label: "485111 - Mixed Mode Transit Systems" },
  { value: "485112", label: "485112 - Commuter Rail Systems" },
  { value: "485113", label: "485113 - Bus and Other Motor Vehicle Transit Systems" },
  { value: "485119", label: "485119 - Other Urban Transit Systems" },
  { value: "485210", label: "485210 - Interurban and Rural Bus Transportation" },
  { value: "485310", label: "485310 - Taxi and Ridesharing Services" },
  { value: "485320", label: "485320 - Limousine Service" },
  { value: "485410", label: "485410 - School and Employee Bus Transportation" },
  { value: "485510", label: "485510 - Charter Bus Industry" },
  { value: "485991", label: "485991 - Special Needs Transportation" },
  { value: "485999", label: "485999 - All Other Transit and Ground Passenger Transportation" },
  { value: "486110", label: "486110 - Pipeline Transportation of Crude Oil" },
  { value: "486210", label: "486210 - Pipeline Transportation of Natural Gas" },
  { value: "486910", label: "486910 - Pipeline Transportation of Refined Petroleum Products" },
  { value: "486990", label: "486990 - All Other Pipeline Transportation" },
  { value: "487110", label: "487110 - Scenic and Sightseeing Transportation, Land" },
  { value: "487210", label: "487210 - Scenic and Sightseeing Transportation, Water" },
  { value: "487990", label: "487990 - Scenic and Sightseeing Transportation, Other" },
  { value: "488111", label: "488111 - Air Traffic Control" },
  { value: "488119", label: "488119 - Other Airport Operations" },
  { value: "488190", label: "488190 - Other Support Activities for Air Transportation" },
  { value: "488210", label: "488210 - Support Activities for Rail Transportation" },
  { value: "488310", label: "488310 - Port and Harbor Operations" },
  { value: "488320", label: "488320 - Marine Cargo Handling" },
  { value: "488330", label: "488330 - Navigational Services to Shipping" },
  { value: "488390", label: "488390 - Other Support Activities for Water Transportation" },
  { value: "488410", label: "488410 - Motor Vehicle Towing" },
  { value: "488490", label: "488490 - Other Support Activities for Road Transportation" },
  { value: "488510", label: "488510 - Freight Transportation Arrangement" },
  { value: "488991", label: "488991 - Packing and Crating" },
  { value: "488999", label: "488999 - All Other Support Activities for Transportation" },
  { value: "491110", label: "491110 - Postal Service" },
  { value: "492110", label: "492110 - Couriers and Express Delivery Services" },
  { value: "492210", label: "492210 - Local Messengers and Local Delivery" },
  { value: "493110", label: "493110 - General Warehousing and Storage" },
  { value: "493120", label: "493120 - Refrigerated Warehousing and Storage" },
  { value: "493130", label: "493130 - Farm Product Warehousing and Storage" },
  { value: "493190", label: "493190 - Other Warehousing and Storage" },

  // Information
  { value: "511110", label: "511110 - Newspaper Publishers" },
  { value: "511120", label: "511120 - Periodical Publishers" },
  { value: "511130", label: "511130 - Book Publishers" },
  { value: "511140", label: "511140 - Directory and Mailing List Publishers" },
  { value: "511190", label: "511190 - Other Publishers" },
  { value: "511210", label: "511210 - Software Publishers" },
  { value: "512110", label: "512110 - Motion Picture and Video Production" },
  { value: "512120", label: "512120 - Motion Picture and Video Distribution" },
  { value: "512131", label: "512131 - Motion Picture Theaters (except Drive-Ins)" },
  { value: "512132", label: "512132 - Drive-In Motion Picture Theaters" },
  { value: "512191", label: "512191 - Teleproduction and Other Postproduction Services" },
  { value: "512199", label: "512199 - Other Motion Picture and Video Industries" },
  { value: "512230", label: "512230 - Music Publishers" },
  { value: "512240", label: "512240 - Sound Recording Studios" },
  { value: "512250", label: "512250 - Record Production and Distribution" },
  { value: "512290", label: "512290 - Other Sound Recording Industries" },
  { value: "515111", label: "515111 - Radio Networks" },
  { value: "515112", label: "515112 - Radio Stations" },
  { value: "515120", label: "515120 - Television Broadcasting" },
  { value: "515210", label: "515210 - Cable and Other Subscription Programming" },
  { value: "516110", label: "516110 - Media Streaming Distribution Services, Social Networks, and Other Media Networks and Content Providers" },
  { value: "517111", label: "517111 - Wired Telecommunications Carriers" },
  { value: "517112", label: "517112 - Wireless Telecommunications Carriers (except Satellite)" },
  { value: "517310", label: "517310 - Telecommunications Resellers" },
  { value: "517410", label: "517410 - Satellite Telecommunications" },
  { value: "517919", label: "517919 - All Other Telecommunications" },
  { value: "518210", label: "518210 - Computing Infrastructure Providers, Data Processing, Web Hosting, and Related Services" },
  { value: "519110", label: "519110 - News Syndicates" },
  { value: "519120", label: "519120 - Libraries and Archives" },
  { value: "519130", label: "519130 - Internet Publishing and Broadcasting and Web Search Portals" },
  { value: "519190", label: "519190 - All Other Information Services" },

  // Finance and Insurance
  { value: "521110", label: "521110 - Monetary Authorities-Central Bank" },
  { value: "522110", label: "522110 - Commercial Banking" },
  { value: "522120", label: "522120 - Savings Institutions, Federally Chartered" },
  { value: "522130", label: "522130 - Savings Institutions, Not Federally Chartered" },
  { value: "522180", label: "522180 - Credit Unions" },
  { value: "522190", label: "522190 - Other Depository Credit Intermediation" },
  { value: "522210", label: "522210 - Credit Card Issuing" },
  { value: "522220", label: "522220 - Sales Financing" },
  { value: "522291", label: "522291 - Consumer Lending" },
  { value: "522292", label: "522292 - Real Estate Credit" },
  { value: "522299", label: "522299 - All Other Nondepository Credit Intermediation" },
  { value: "522310", label: "522310 - Mortgage and Nonmortgage Loan Brokers" },
  { value: "522320", label: "522320 - Financial Transactions Processing, Reserve, and Clearinghouse Activities" },
  { value: "522390", label: "522390 - Other Activities Related to Credit Intermediation" },
  { value: "523110", label: "523110 - Investment Banking and Securities Dealing" },
  { value: "523120", label: "523120 - Securities Brokerage" },
  { value: "523130", label: "523130 - Commodity Contracts Dealing" },
  { value: "523140", label: "523140 - Commodity Contracts Brokerage" },
  { value: "523210", label: "523210 - Securities and Commodity Exchanges" },
  { value: "523910", label: "523910 - Miscellaneous Intermediation" },
  { value: "523920", label: "523920 - Portfolio Management" },
  { value: "523930", label: "523930 - Investment Advice" },
  { value: "523991", label: "523991 - Trust, Fiduciary, and Custody Activities" },
  { value: "523999", label: "523999 - Miscellaneous Financial Investment Activities" },
  { value: "524113", label: "524113 - Direct Life Insurance Carriers" },
  { value: "524114", label: "524114 - Direct Health and Medical Insurance Carriers" },
  { value: "524126", label: "524126 - Direct Property and Casualty Insurance Carriers" },
  { value: "524127", label: "524127 - Direct Title Insurance Carriers" },
  { value: "524128", label: "524128 - Other Direct Insurance (except Life, Health, and Medical) Carriers" },
  { value: "524130", label: "524130 - Reinsurance Carriers" },
  { value: "524210", label: "524210 - Insurance Agencies and Brokerages" },
  { value: "524291", label: "524291 - Claims Adjusting" },
  { value: "524292", label: "524292 - Pharmacy Benefit Management" },
  { value: "524298", label: "524298 - All Other Insurance Related Activities" },
  { value: "525110", label: "525110 - Pension Funds" },
  { value: "525120", label: "525120 - Health and Welfare Funds" },
  { value: "525190", label: "525190 - Other Insurance Funds" },
  { value: "525910", label: "525910 - Open-End Investment Funds" },
  { value: "525920", label: "525920 - Trusts, Estates, and Agency Accounts" },
  { value: "525990", label: "525990 - Other Financial Vehicles" },

  // Real Estate and Rental and Leasing
  { value: "531110", label: "531110 - Lessors of Residential Buildings and Dwellings" },
  { value: "531120", label: "531120 - Lessors of Nonresidential Buildings (except Miniwarehouses)" },
  { value: "531130", label: "531130 - Lessors of Miniwarehouses and Self-Storage Units" },
  { value: "531190", label: "531190 - Lessors of Other Real Estate Property" },
  { value: "531210", label: "531210 - Offices of Real Estate Agents and Brokers" },
  { value: "531311", label: "531311 - Residential Property Managers" },
  { value: "531312", label: "531312 - Nonresidential Property Managers" },
  { value: "531320", label: "531320 - Offices of Real Estate Appraisers" },
  { value: "531390", label: "531390 - Other Activities Related to Real Estate" },
  { value: "532111", label: "532111 - Passenger Car Rental" },
  { value: "532112", label: "532112 - Passenger Car Leasing" },
  { value: "532120", label: "532120 - Truck, Utility Trailer, and RV (Recreational Vehicle) Rental and Leasing" },
  { value: "532210", label: "532210 - Consumer Electronics and Appliances Rental" },
  { value: "532281", label: "532281 - Formal Wear and Costume Rental" },
  { value: "532282", label: "532282 - Video Tape and Disc Rental" },
  { value: "532283", label: "532283 - Home Health Equipment Rental" },
  { value: "532284", label: "532284 - Recreational Goods Rental" },
  { value: "532289", label: "532289 - All Other Consumer Goods Rental" },
  { value: "532310", label: "532310 - General Rental Centers" },
  { value: "532411", label: "532411 - Commercial Air, Rail, and Water Transportation Equipment Rental and Leasing" },
  { value: "532412", label: "532412 - Construction, Mining, and Forestry Machinery and Equipment Rental and Leasing" },
  { value: "532420", label: "532420 - Office Machinery and Equipment Rental and Leasing" },
  { value: "532490", label: "532490 - Other Commercial and Industrial Machinery and Equipment Rental and Leasing" },
  { value: "533110", label: "533110 - Lessors of Nonfinancial Intangible Assets (except Copyrighted Works)" },

  // Professional, Scientific, and Technical Services
  { value: "541110", label: "541110 - Offices of Lawyers" },
  { value: "541120", label: "541120 - Offices of Notaries" },
  { value: "541191", label: "541191 - Title Abstract and Settlement Offices" },
  { value: "541199", label: "541199 - All Other Legal Services" },
  { value: "541211", label: "541211 - Offices of Certified Public Accountants" },
  { value: "541213", label: "541213 - Tax Preparation Services" },
  { value: "541214", label: "541214 - Payroll Services" },
  { value: "541219", label: "541219 - Other Accounting Services" },
  { value: "541310", label: "541310 - Architectural Services" },
  { value: "541320", label: "541320 - Landscape Architectural Services" },
  { value: "541330", label: "541330 - Engineering Services" },
  { value: "541340", label: "541340 - Drafting Services" },
  { value: "541350", label: "541350 - Building Inspection Services" },
  { value: "541360", label: "541360 - Geophysical Surveying and Mapping Services" },
  { value: "541370", label: "541370 - Surveying and Mapping (except Geophysical) Services" },
  { value: "541380", label: "541380 - Testing Laboratories and Services" },
  { value: "541410", label: "541410 - Interior Design Services" },
  { value: "541420", label: "541420 - Industrial Design Services" },
  { value: "541430", label: "541430 - Graphic Design Services" },
  { value: "541490", label: "541490 - Other Specialized Design Services" },
  { value: "541511", label: "541511 - Custom Computer Programming Services" },
  { value: "541512", label: "541512 - Computer Systems Design Services" },
  { value: "541513", label: "541513 - Computer Facilities Management Services" },
  { value: "541519", label: "541519 - Other Computer Related Services" },
  { value: "541611", label: "541611 - Administrative Management and General Management Consulting Services" },
  { value: "541612", label: "541612 - Human Resources Consulting Services" },
  { value: "541613", label: "541613 - Marketing Consulting Services" },
  { value: "541614", label: "541614 - Process, Physical Distribution, and Logistics Consulting Services" },
  { value: "541618", label: "541618 - Other Management Consulting Services" },
  { value: "541620", label: "541620 - Environmental Consulting Services" },
  { value: "541690", label: "541690 - Other Scientific and Technical Consulting Services" },
  { value: "541711", label: "541711 - Research and Development in Biotechnology (except Nanobiotechnology)" },
  { value: "541712", label: "541712 - Research and Development in the Physical, Engineering, and Life Sciences (except Nanotechnology and Biotechnology)" },
  { value: "541713", label: "541713 - Research and Development in Nanotechnology" },
  { value: "541720", label: "541720 - Research and Development in the Social Sciences and Humanities" },
  { value: "541810", label: "541810 - Advertising Agencies" },
  { value: "541820", label: "541820 - Public Relations Agencies" },
  { value: "541830", label: "541830 - Media Buying Agencies" },
  { value: "541840", label: "541840 - Media Representatives" },
  { value: "541850", label: "541850 - Indoor and Outdoor Display Advertising" },
  { value: "541860", label: "541860 - Direct Mail Advertising" },
  { value: "541870", label: "541870 - Advertising Material Distribution Services" },
  { value: "541890", label: "541890 - Other Services Related to Advertising" },
  { value: "541910", label: "541910 - Marketing Research and Public Opinion Polling" },
  { value: "541921", label: "541921 - Photography Studios, Portrait" },
  { value: "541922", label: "541922 - Commercial Photography" },
  { value: "541930", label: "541930 - Translation and Interpretation Services" },
  { value: "541940", label: "541940 - Veterinary Services" },
  { value: "541990", label: "541990 - All Other Professional, Scientific, and Technical Services" },

  // Management of Companies and Enterprises
  { value: "551111", label: "551111 - Offices of Bank Holding Companies" },
  { value: "551112", label: "551112 - Offices of Other Holding Companies" },
  { value: "551114", label: "551114 - Corporate, Subsidiary, and Regional Managing Offices" },

  // Administrative and Support and Waste Management
  { value: "561110", label: "561110 - Office Administrative Services" },
  { value: "561210", label: "561210 - Facilities Support Services" },
  { value: "561311", label: "561311 - Employment Placement Agencies" },
  { value: "561312", label: "561312 - Executive Search Services" },
  { value: "561320", label: "561320 - Temporary Help Services" },
  { value: "561330", label: "561330 - Professional Employer Organizations" },
  { value: "561410", label: "561410 - Document Preparation Services" },
  { value: "561421", label: "561421 - Telephone Answering Services" },
  { value: "561422", label: "561422 - Telemarketing Bureaus and Other Contact Centers" },
  { value: "561431", label: "561431 - Private Mail Centers" },
  { value: "561439", label: "561439 - Other Business Service Centers (including Copy Shops)" },
  { value: "561440", label: "561440 - Collection Agencies" },
  { value: "561450", label: "561450 - Credit Bureaus" },
  { value: "561491", label: "561491 - Repossession Services" },
  { value: "561492", label: "561492 - Court Reporting and Stenotype Services" },
  { value: "561499", label: "561499 - All Other Business Support Services" },
  { value: "561510", label: "561510 - Travel Agencies" },
  { value: "561520", label: "561520 - Tour Operators" },
  { value: "561591", label: "561591 - Convention and Visitors Bureaus" },
  { value: "561599", label: "561599 - All Other Travel Arrangement and Reservation Services" },
  { value: "561611", label: "561611 - Investigation, Guard, and Armored Car Services" },
  { value: "561612", label: "561612 - Security Guards and Patrol Services" },
  { value: "561613", label: "561613 - Armored Car Services" },
  { value: "561621", label: "561621 - Security Systems Services (except Locksmiths)" },
  { value: "561622", label: "561622 - Locksmiths" },
  { value: "561710", label: "561710 - Exterminating and Pest Control Services" },
  { value: "561720", label: "561720 - Janitorial Services" },
  { value: "561730", label: "561730 - Landscaping Services" },
  { value: "561740", label: "561740 - Carpet and Upholstery Cleaning Services" },
  { value: "561790", label: "561790 - Other Services to Buildings and Dwellings" },
  { value: "561910", label: "561910 - Packaging and Labeling Services" },
  { value: "561920", label: "561920 - Convention and Trade Show Organizers" },
  { value: "561990", label: "561990 - All Other Support Services" },
  { value: "562111", label: "562111 - Solid Waste Collection" },
  { value: "562112", label: "562112 - Hazardous Waste Collection" },
  { value: "562119", label: "562119 - Other Waste Collection" },
  { value: "562211", label: "562211 - Hazardous Waste Treatment and Disposal" },
  { value: "562212", label: "562212 - Solid Waste Landfill" },
  { value: "562213", label: "562213 - Solid Waste Combustors and Incinerators" },
  { value: "562219", label: "562219 - Other Nonhazardous Waste Treatment and Disposal" },
  { value: "562910", label: "562910 - Remediation Services" },
  { value: "562920", label: "562920 - Materials Recovery Facilities" },
  { value: "562991", label: "562991 - Septic Tank and Related Services" },
  { value: "562998", label: "562998 - All Other Miscellaneous Waste Management Services" },

  // Educational Services
  { value: "611110", label: "611110 - Elementary and Secondary Schools" },
  { value: "611210", label: "611210 - Junior Colleges" },
  { value: "611310", label: "611310 - Colleges, Universities, and Professional Schools" },
  { value: "611410", label: "611410 - Business and Secretarial Schools" },
  { value: "611420", label: "611420 - Computer Training" },
  { value: "611430", label: "611430 - Professional and Management Development Training" },
  { value: "611511", label: "611511 - Cosmetology, Barber, Manicure, and Esthetics Schools" },
  { value: "611512", label: "611512 - Flight Training" },
  { value: "611513", label: "611513 - Apprenticeship Training" },
  { value: "611519", label: "611519 - Other Technical and Trade Schools" },
  { value: "611610", label: "611610 - Fine Arts Schools" },
  { value: "611620", label: "611620 - Sports and Recreation Instruction" },
  { value: "611630", label: "611630 - Language Schools" },
  { value: "611691", label: "611691 - Exam Preparation and Tutoring" },
  { value: "611692", label: "611692 - Automobile Driving Schools" },
  { value: "611699", label: "611699 - All Other Miscellaneous Schools and Instruction" },
  { value: "611710", label: "611710 - Educational Support Services" },

  // Health Care and Social Assistance
  { value: "621111", label: "621111 - Offices of Physicians (except Mental Health Specialists)" },
  { value: "621112", label: "621112 - Offices of Physicians, Mental Health Specialists" },
  { value: "621210", label: "621210 - Offices of Dentists" },
  { value: "621310", label: "621310 - Offices of Chiropractors" },
  { value: "621320", label: "621320 - Offices of Optometrists" },
  { value: "621330", label: "621330 - Offices of Mental Health Practitioners (except Physicians)" },
  { value: "621340", label: "621340 - Offices of Physical, Occupational and Speech Therapists, and Audiologists" },
  { value: "621391", label: "621391 - Offices of Podiatrists" },
  { value: "621399", label: "621399 - Offices of All Other Miscellaneous Health Practitioners" },
  { value: "621410", label: "621410 - Family Planning Centers" },
  { value: "621420", label: "621420 - Outpatient Mental Health and Substance Abuse Centers" },
  { value: "621491", label: "621491 - HMO Medical Centers" },
  { value: "621492", label: "621492 - Kidney Dialysis Centers" },
  { value: "621493", label: "621493 - Freestanding Ambulatory Surgical and Emergency Centers" },
  { value: "621498", label: "621498 - All Other Outpatient Care Centers" },
  { value: "621511", label: "621511 - Medical Laboratories" },
  { value: "621512", label: "621512 - Diagnostic Imaging Centers" },
  { value: "621610", label: "621610 - Home Health Care Services" },
  { value: "621910", label: "621910 - Ambulance Services" },
  { value: "621991", label: "621991 - Blood and Organ Banks" },
  { value: "621999", label: "621999 - All Other Miscellaneous Ambulatory Health Care Services" },
  { value: "622110", label: "622110 - General Medical and Surgical Hospitals" },
  { value: "622210", label: "622210 - Psychiatric and Substance Abuse Hospitals" },
  { value: "622310", label: "622310 - Specialty (except Psychiatric and Substance Abuse) Hospitals" },
  { value: "623110", label: "623110 - Nursing Care Facilities (Skilled Nursing Facilities)" },
  { value: "623210", label: "623210 - Residential Intellectual and Developmental Disability Facilities" },
  { value: "623220", label: "623220 - Residential Mental Health and Substance Abuse Facilities" },
  { value: "623311", label: "623311 - Continuing Care Retirement Communities" },
  { value: "623312", label: "623312 - Assisted Living Facilities for the Elderly" },
  { value: "623990", label: "623990 - Other Residential Care Facilities" },
  { value: "624110", label: "624110 - Child and Youth Services" },
  { value: "624120", label: "624120 - Services for the Elderly and Persons with Disabilities" },
  { value: "624190", label: "624190 - Other Individual and Family Services" },
  { value: "624210", label: "624210 - Community Food Services" },
  { value: "624221", label: "624221 - Temporary Shelters" },
  { value: "624229", label: "624229 - Other Community Housing Services" },
  { value: "624230", label: "624230 - Emergency and Other Relief Services" },
  { value: "624310", label: "624310 - Vocational Rehabilitation Services" },
  { value: "624410", label: "624410 - Child Day Care Services" },

  // Arts, Entertainment, and Recreation
  { value: "711110", label: "711110 - Theater Companies and Dinner Theaters" },
  { value: "711120", label: "711120 - Dance Companies" },
  { value: "711130", label: "711130 - Musical Groups and Artists" },
  { value: "711190", label: "711190 - Other Performing Arts Companies" },
  { value: "711211", label: "711211 - Sports Teams and Clubs" },
  { value: "711212", label: "711212 - Racetracks" },
  { value: "711219", label: "711219 - Other Spectator Sports" },
  { value: "711310", label: "711310 - Promoters of Performing Arts, Sports, and Similar Events with Facilities" },
  { value: "711320", label: "711320 - Promoters of Performing Arts, Sports, and Similar Events without Facilities" },
  { value: "711410", label: "711410 - Agents and Managers for Artists, Athletes, Entertainers, and Other Public Figures" },
  { value: "711510", label: "711510 - Independent Artists, Writers, and Performers" },
  { value: "712110", label: "712110 - Museums" },
  { value: "712120", label: "712120 - Historical Sites" },
  { value: "712130", label: "712130 - Zoos and Botanical Gardens" },
  { value: "712190", label: "712190 - Nature Parks and Other Similar Institutions" },
  { value: "713110", label: "713110 - Amusement and Theme Parks" },
  { value: "713120", label: "713120 - Amusement Arcades" },
  { value: "713210", label: "713210 - Casinos (except Casino Hotels)" },
  { value: "713290", label: "713290 - Other Gambling Industries" },
  { value: "713910", label: "713910 - Golf Courses and Country Clubs" },
  { value: "713920", label: "713920 - Skiing Facilities" },
  { value: "713930", label: "713930 - Marinas" },
  { value: "713940", label: "713940 - Fitness and Recreational Sports Centers" },
  { value: "713950", label: "713950 - Bowling Centers" },
  { value: "713990", label: "713990 - All Other Amusement and Recreation Industries" },

  // Accommodation and Food Services
  { value: "721110", label: "721110 - Hotels (except Casino Hotels) and Motels" },
  { value: "721120", label: "721120 - Casino Hotels" },
  { value: "721191", label: "721191 - Bed-and-Breakfast Inns" },
  { value: "721199", label: "721199 - All Other Traveler Accommodation" },
  { value: "721211", label: "721211 - RV (Recreational Vehicle) Parks and Campgrounds" },
  { value: "721214", label: "721214 - Recreational and Vacation Camps (except Campgrounds)" },
  { value: "721310", label: "721310 - Rooming and Boarding Houses, Dormitories, and Workers' Camps" },
  { value: "722310", label: "722310 - Food Service Contractors" },
  { value: "722320", label: "722320 - Caterers" },
  { value: "722330", label: "722330 - Mobile Food Services" },
  { value: "722410", label: "722410 - Drinking Places (Alcoholic Beverages)" },
  { value: "722511", label: "722511 - Full-Service Restaurants" },
  { value: "722513", label: "722513 - Limited-Service Restaurants" },
  { value: "722514", label: "722514 - Cafeterias, Grill Buffets, and Buffets" },
  { value: "722515", label: "722515 - Snack and Nonalcoholic Beverage Bars" },

  // Other Services (except Public Administration)
  { value: "811111", label: "811111 - General Automotive Repair" },
  { value: "811112", label: "811112 - Automotive Exhaust System Repair" },
  { value: "811113", label: "811113 - Automotive Transmission Repair" },
  { value: "811118", label: "811118 - Other Automotive Mechanical and Electrical Repair and Maintenance" },
  { value: "811121", label: "811121 - Automotive Body, Paint, and Interior Repair and Maintenance" },
  { value: "811122", label: "811122 - Automotive Glass Replacement Shops" },
  { value: "811191", label: "811191 - Automotive Oil Change and Lubrication Shops" },
  { value: "811192", label: "811192 - Car Washes" },
  { value: "811198", label: "811198 - All Other Automotive Repair and Maintenance" },
  { value: "811211", label: "811211 - Consumer Electronics Repair and Maintenance" },
  { value: "811212", label: "811212 - Computer and Office Machine Repair and Maintenance" },
  { value: "811213", label: "811213 - Communication Equipment Repair and Maintenance" },
  { value: "811219", label: "811219 - Other Electronic and Precision Equipment Repair and Maintenance" },
  { value: "811310", label: "811310 - Commercial and Industrial Machinery and Equipment (except Automotive and Electronic) Repair and Maintenance" },
  { value: "811411", label: "811411 - Home and Garden Equipment Repair and Maintenance" },
  { value: "811412", label: "811412 - Appliance Repair and Maintenance" },
  { value: "811420", label: "811420 - Reupholstery and Furniture Repair" },
  { value: "811430", label: "811430 - Footwear and Leather Goods Repair" },
  { value: "811490", label: "811490 - Other Personal and Household Goods Repair and Maintenance" },
  { value: "812111", label: "812111 - Barber Shops" },
  { value: "812112", label: "812112 - Beauty Salons" },
  { value: "812113", label: "812113 - Nail Salons" },
  { value: "812191", label: "812191 - Diet and Weight Reducing Centers" },
  { value: "812199", label: "812199 - Other Personal Care Services" },
  { value: "812210", label: "812210 - Funeral Homes and Funeral Services" },
  { value: "812220", label: "812220 - Cemeteries and Crematoria" },
  { value: "812310", label: "812310 - Coin-Operated Laundries and Drycleaners" },
  { value: "812320", label: "812320 - Drycleaning and Laundry Services (except Coin-Operated)" },
  { value: "812331", label: "812331 - Linen Supply" },
  { value: "812332", label: "812332 - Industrial Launderers" },
  { value: "812910", label: "812910 - Pet Care (except Veterinary) Services" },
  { value: "812921", label: "812921 - Photofinishing Laboratories (except One-Hour)" },
  { value: "812922", label: "812922 - One-Hour Photofinishing" },
  { value: "812930", label: "812930 - Parking Lots and Garages" },
  { value: "812990", label: "812990 - All Other Personal Services" },
  { value: "813110", label: "813110 - Religious Organizations" },
  { value: "813211", label: "813211 - Grantmaking Foundations" },
  { value: "813212", label: "813212 - Voluntary Health Organizations" },
  { value: "813219", label: "813219 - Other Grantmaking and Giving Services" },
  { value: "813311", label: "813311 - Human Rights Organizations" },
  { value: "813312", label: "813312 - Environment, Conservation and Wildlife Organizations" },
  { value: "813319", label: "813319 - Other Social Advocacy Organizations" },
  { value: "813410", label: "813410 - Civic and Social Organizations" },
  { value: "813910", label: "813910 - Business Associations" },
  { value: "813920", label: "813920 - Professional Organizations" },
  { value: "813930", label: "813930 - Labor Unions and Similar Labor Organizations" },
  { value: "813940", label: "813940 - Political Organizations" },
  { value: "813990", label: "813990 - Other Similar Organizations (except Business, Professional, Labor, and Political Organizations)" },
  { value: "814110", label: "814110 - Private Households" },

  // Public Administration
  { value: "921110", label: "921110 - Executive Offices" },
  { value: "921120", label: "921120 - Legislative Bodies" },
  { value: "921130", label: "921130 - Public Finance Activities" },
  { value: "921140", label: "921140 - Executive and Legislative Offices, Combined" },
  { value: "921150", label: "921150 - American Indian and Alaska Native Tribal Governments" },
  { value: "921190", label: "921190 - Other General Government Support" },
  { value: "922110", label: "922110 - Courts" },
  { value: "922120", label: "922120 - Police Protection" },
  { value: "922130", label: "922130 - Legal Counsel and Prosecution" },
  { value: "922140", label: "922140 - Correctional Institutions" },
  { value: "922150", label: "922150 - Parole Offices and Probation Offices" },
  { value: "922160", label: "922160 - Fire Protection" },
  { value: "922190", label: "922190 - Other Justice, Public Order, and Safety Activities" },
  { value: "923110", label: "923110 - Administration of Education Programs" },
  { value: "923120", label: "923120 - Administration of Public Health Programs" },
  { value: "923130", label: "923130 - Administration of Human Resource Programs (except Education, Public Health, and Veterans' Affairs Programs)" },
  { value: "923140", label: "923140 - Administration of Veterans' Affairs" },
  { value: "924110", label: "924110 - Administration of Air and Water Resource and Solid Waste Management Programs" },
  { value: "924120", label: "924120 - Administration of Conservation Programs" },
  { value: "925110", label: "925110 - Administration of Housing Programs" },
  { value: "925120", label: "925120 - Administration of Urban Planning and Community and Rural Development" },
  { value: "926110", label: "926110 - Administration of General Economic Programs" },
  { value: "926120", label: "926120 - Regulation and Administration of Transportation Programs" },
  { value: "926130", label: "926130 - Regulation and Administration of Communications, Electric, Gas, and Other Utilities" },
  { value: "926140", label: "926140 - Regulation of Agricultural Marketing and Commodities" },
  { value: "926150", label: "926150 - Regulation, Licensing, and Inspection of Miscellaneous Commercial Sectors" },
  { value: "927110", label: "927110 - Space Research and Technology" },
  { value: "928110", label: "928110 - National Security" },
  { value: "928120", label: "928120 - International Affairs" },
]

/**
 * Look up a NAICS code label by its value.
 * Returns the code itself if not found in the list.
 */
export function getNaicsLabel(code: string): string {
  const found = NAICS_CODES.find(n => n.value === code)
  return found ? found.label : code
}
